<div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="table">
        @if (config().showSerialNumber) {
        <ng-container matColumnDef="serialNumber" sticky>
            <th mat-header-cell *matHeaderCellDef>S.No</th>
            <td mat-cell *matCellDef="let element; let i = index">{{i + 1}}</td>
        </ng-container>
        }

        @for (column of columns(); track column.key) {
        <ng-container [matColumnDef]="column.key">
            <th mat-header-cell *matHeaderCellDef>
                {{column.header}}
            </th>

            <td mat-cell *matCellDef="let element" [class]="column.styleClass">
                {{ element[column.key]}}
            </td>
        </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: config().stickyHeader" class="table-header-bg">
        </tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
        <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->

        <!-- No data row -->
        <tr  class="mat-mdc-row mat-row" *matNoDataRow>
            <td align="center" class="mat-cell no-data-row" [attr.colspan]="displayedColumns.length">
                No data found
            </td>
        </tr>
    </table>
</div>